import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faLocationDot, faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import BegoNuFernandez from "../img/begonuferbackground.png";
import { ArrowDownIcon, ArrowIcon } from "./ArrowIcon";
import emailjs from 'emailjs-com';
import i18next from 'i18next';

emailjs.init('qz6RdDJQwVJSPAj1W');

export const Contact = () => {

    const handleSubmit = (e) => {
        e.preventDefault();
    
        const email = document.getElementById('emailInput').value;
        const name = document.getElementById('nameInput').value;
        const message = document.getElementById('textAreaInput').value;

        if (email.trim() === '' || name.trim() === '' || message.trim() === '') {
            alert(i18next.t('alertFormIncomplete'));
            return;
        }

        if (!isValidEmail(email)) {
            alert(i18next.t('alertInvalidEmailAddress'));
            return;
        }

    
        emailjs.send('service_3wgm3py', 'template_z88hk1w', { from_email: email, from_name: name, message: message })
            .then((response) => {
                console.log('Email enviado con éxito!', response.status, response.text);
                alert(i18next.t('alertSuccessfullySend'));
            }, (error) => {
                console.error('Error al enviar el email:', error);
                alert(i18next.t('alertFailedSend'));
            });    
        
        document.getElementById('emailInput').value = '';
        document.getElementById('nameInput').value = '';
        document.getElementById('textAreaInput').value = '';
    }

    const isValidEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    return (
        <>
            <div className="page-content text-center d-flex align-items-center flex-column text-white">
                <h1 className="section-title">
                    {i18next.t('contact')}
                </h1>
                <div className="section-content" id="contactContent">
                    <div className="d-flex justify-content-center">
                        <img src={BegoNuFernandez} className="about-img for-tablet p-0 m-0" alt="Bego Nuñez Fernandez"/>
                    </div>
                    <div>
                        <p className="d-flex align-items-center justify-content-center pt-3">
                            <FontAwesomeIcon icon={faLocationDot} size="3x"/>
                            <h2 className="contact-gap">{i18next.t('location')}</h2>
                        </p>
                        <p className="d-flex align-items-center justify-content-center pt-3 ps-2">
                            <FontAwesomeIcon icon={faEnvelope} size="3x"/> 
                            <h2 className="contact-gap">{i18next.t('sendEmail')}</h2> 
                            {window.innerWidth <= 1024 ? <ArrowDownIcon /> : <ArrowIcon />}
                        </p>
                    </div>
                    <div className="col-lg-4 m-4 content-page-skills p-3">
                        <input type="email" className="form-contact p-3 mb-2" id="emailInput" placeholder={i18next.t('emailPlaceholder')} />
                        <input className="form-contact p-3 mb-2" id="nameInput" placeholder={i18next.t('namePlaceholder')} />
                        <textarea className="form-contact p-3 mb-2" id="textAreaInput" rows="12" placeholder={i18next.t('messagePlaceholder')}></textarea>
                        <button type="submit" className="btn bottom-button send-btn border-white text-white px-4 py-2 fs-5" onClick={handleSubmit}>
                            {i18next.t('send')}
                            <FontAwesomeIcon icon={faPaperPlane} size="1x" className="ps-2"/>
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

